var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Utils
import { fetchData } from '../../fetchData';
import { isValidResponse } from './isValidResponse';
import { isAbortError, isError } from '../../errors';
import { getFetchError } from '../../errors/getFetchError';
import { getUnresolvableDataError } from '../../errors/getUnresolvableDataError';
/**
 * @description Performs a fetch action for the fetchStateMachine.
 *
 * @param {PerformFetchProps} props - The properties for performing the fetch.
 * @returns {Promise<void>} - A promise that resolves when the fetch action is completed.
 * @throws {Error} - If there is an error fetching search results or
 * if the backend response format is invalid.
 */
export var performFetch = function (_a) {
    var method = _a.method, url = _a.url, body = _a.body, headers = _a.headers, abortSignal = _a.abortSignal, isDataResolvable = _a.isDataResolvable, onResolve = _a.onResolve, onReject = _a.onReject;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, response, error, data, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetchData({
                            url: url,
                            method: method,
                            headers: headers,
                            body: body,
                            abortSignal: abortSignal,
                        })];
                case 1:
                    _b = _c.sent(), response = _b.response, error = _b.error;
                    if (isAbortError(error)) {
                        // Abort error is neither resolved or rejected. When the abort action is performed,
                        // then the state machine will transition back to idle (the abort action handler will
                        // have a callback to notify the user the request has been aborted)
                        return [2 /*return*/];
                    }
                    if (!isValidResponse(response)) {
                        onReject(getFetchError(), { response: response });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _c.sent();
                    if (isDataResolvable(data)) {
                        onResolve(data);
                    }
                    else {
                        onReject(getUnresolvableDataError(), { response: response });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    if (isError(error_1)) {
                        onReject(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=performFetch.js.map